export interface RheroTheme {
  id: string;
  name: string;
  mode: "light" | "dark";
  swatch: string;
}

export const RHERO_THEME_KEY = "rhero.theme";

/** R-Hero Light is first and is the default for a dispatcher with no saved theme. */
export const RHERO_THEMES: RheroTheme[] = [
  { id: "rhero-light", name: "R-Hero Light", mode: "light", swatch: "linear-gradient(135deg,#F4F7F9 58%,#007F73 58%)" },
  { id: "rhero-dark", name: "R-Hero Dark", mode: "dark", swatch: "linear-gradient(135deg,#1E2329 58%,#14b8a6 58%)" },
  { id: "rhero-black", name: "R-Hero Black", mode: "dark", swatch: "linear-gradient(135deg,#2A2D31 58%,#FFC107 58%)" }
];

export function rheroThemeById(id?: string | null): RheroTheme {
  return RHERO_THEMES.find((theme) => theme.id === id) || RHERO_THEMES[0];
}

/** Apply a theme immediately. Persists rhero.theme. Unknown ids fall back to R-Hero Light. */
export function applyRheroTheme(id?: string | null): RheroTheme {
  const theme = rheroThemeById(id);
  const root = document.documentElement;
  root.setAttribute("data-rhero-theme", theme.id);
  root.setAttribute("data-rh-theme", theme.id);
  const dark = theme.mode === "dark";
  root.classList.toggle("dark", dark);
  root.setAttribute("data-bs-theme", dark ? "dark" : "light");
  root.style.colorScheme = dark ? "dark" : "light";
  root.dispatchEvent(new Event("rhero-theme"));
  try {
    localStorage.setItem(RHERO_THEME_KEY, theme.id);
  } catch {
    /* private mode still gets the live attribute */
  }
  return theme;
}

export function bootRheroTheme(): RheroTheme {
  let stored: string | null = null;
  try {
    // One-time reset so everyone lands on R-Hero Light after the v20 deploy (Oct 5 2026).
    if (!localStorage.getItem("rhero.theme.reset2")) {
      localStorage.setItem("rhero.theme.reset2", "1");
      localStorage.removeItem(RHERO_THEME_KEY);
    }
    stored = localStorage.getItem(RHERO_THEME_KEY);
  } catch {
    stored = null;
  }
  return applyRheroTheme(stored);
}
